import type { ShippingAddress } from '../../../modules/api';

/** "Miami FL, 33127 - US" — the city line of the Figma address block. */
function cityLine({ city, state, zipcode, country }: ShippingAddress): string {
  const cityState = [city, state].filter(Boolean).join(' ');
  return `${cityState}, ${zipcode} - ${country}`;
}

/** The saved address as plain muted lines under "Your Address". */
export function AddressLinesText({ address }: { address: ShippingAddress }) {
  const street = [address.firstLine, address.secondLine].filter(Boolean).join(', ');
  return (
    <p className="m-0 flex flex-col text-[16px] leading-[24px] tracking-[-0.31px] text-[var(--co-ShipCard-mutedText,#6D707C)]">
      <span>{address.name}</span>
      <span>{street}</span>
      <span>{cityLine(address)}</span>
      <span>{address.phoneNumber}</span>
    </p>
  );
}
